import Vue from "vue";
import Router from "vue-router";
// import firebase from "firebase";
import Userauth from "../auth/js/index";

import Body from "../components/body";
import Auth from "../auth/auth";

/* Auth */
import login from "../auth/login.vue";
import Register from "../auth/register";
import ResetAccountPassword from "../auth/ResetAccountPassword";
import LoginSuccessTest from "../pages/auth/loginSuccessTest.vue";

/* Error Pages */
import Error400 from "../errors/error_400";
import Error401 from "../errors/error_401";
import Error403 from "../errors/error_403";
import Error404 from "../errors/error_404";
import Error500 from "../errors/error_500";
import Error503 from "../errors/error_503";

/* Dashboards */
import Default from "../pages/dashboard/default";

/* User Profile */
import UserProfile from "../pages/users/profile";
import UserEditProfile from "../pages/users/edit-profile";
import UserCards from "../pages/users/cards";

/* E-Commerce */
import Products from "../pages/ecommerce/products";
import ProductDetails from "../pages/ecommerce/product_details";
import Cart from "../pages/ecommerce/cart";
import Wishlist from "../pages/ecommerce/wishlist";
import Checkout from "../pages/ecommerce/checkout";
import Invoice from "../pages/ecommerce/invoice";
import Success from "../pages/ecommerce/success";
import OrderHistory from "../pages/ecommerce/order_history";
import OrderHistoryDetail from "../pages/ecommerce/orderhistorydetail";
import PaymentDetails from "../pages/ecommerce/payment_details";

/* Authentication */
import LoginOne from "../pages/authentication/login_one";
import LoginTwo from "../pages/authentication/login_two";
import LoginValidate from "../pages/authentication/login_with_validation";
import RegisterImage from "../pages/authentication/register_image";
import RegisterImage2 from "../pages/authentication/register_image2";
import Unlock from "../pages/authentication/unlock";
import ForgetPassword from "../pages/authentication/forget_password";
import ResetPassword from "../pages/authentication/reset_password";

//Sales Lead
import SalesLead from "../pages/salesLead/default";

//Company Info Center
import CompanyInfoCenter from "../pages/companyInfoCenter/default";
import Report from "../pages/Report/default";

//Product Info Center
import ProductInfoCenter from "../pages/productInfoCenter/default";
import ProductDetail from "../pages/productInfoCenter/productDetail";
import ProductIndex from "../pages/productInfoCenter/indexDetail";

// buyer sourcing wall request
import BuyerRequest from "../pages/BuyerRequest/default"; 

import NewProductInfoCenter from "../pages/NewproductInfoCenter/default";
import NewProductDetail from "../pages/NewproductInfoCenter/productDetail";
import NewProductIndex from "../pages/NewproductInfoCenter/indexDetail";

//Advertisment Service
import AdvertismentInfoCenter from "../pages/advertisingInfoCenter/default";
import AdListView from "../pages/advertisingInfoCenter/AdListView";
import AdDetailView from "../pages/advertisingInfoCenter/AdDetailView";

//News Info Center
import NewsInfoCenter from '../pages/newsCenter/default';
import NewsDetail from '../pages/newsCenter/newsDetail';

//Sourcing Request Center
import sourcingRequestCenter from "../pages/sourcingRequestCenter/default";

//My Account
import MyAccount from "../pages/UserSetting/MyAccount";
import MyUsers from "../pages/UserSetting/MyUsers";

//Business Documents (BR)
import BusinessDocumentsDefault from "../pages/businessDocuments/default";
import BusinessDocumentsAdd from "../pages/businessDocuments/addDocument";


//My Message
import MyMessage from "../pages/myMessage/default";
import MyMessageListing from "../pages/myMessage/listing";
import MyMessageDetail from "../pages/myMessage/detail";

//About Platform
import officialNotice from "../pages/aboutPlatform/officialNotice";
import sourcing_trend_market_analysis from "../pages/aboutPlatform/sourcing_trend_market_analysis";

//profile
import settings from "../pages/profile/settings";

//management
import manageSupplier from "../pages/management/supplier"
import manageAdApproval from "../pages/management/AdApproval"
import manageCompanyApproval from "../pages/management/CompanyApproval"
import managementIndex from "../pages/management/index"
import managementBlacklist from "../pages/management/Blacklist/default"
// Service
import { userService } from "../_services"
import { BR_ENABLED } from "../constants/businessRegistration";

// component
import menu from '../store/modules/menu'
import { authentication } from '../store/modules/authentication'

import visitorGuide from "../pages/visitorGuide/default";

import PIGDetail from "../pages/PIG/component/Detail.vue";

import PIG from "../pages/PIG/default";

import SourcingTrendAndMarketAnalysis from "../pages/sourcingTrendAndMarketAnalysis/default";
import SourcingTrendAndMarketAnalysisDetail from "../pages/sourcingTrendAndMarketAnalysis/detail/detail.vue";

import OpenSearchWordSplitter from "../pages/openSearch/wordSplitter/default.vue";

import AutoReport from "../pages/autoReport/default.vue";
import HotSearchesDefault from "../pages/hotSearches/default.vue";
import ComponetPlayground from "../pages/componetPlayground";
import VideoFormatter from "../pages/VideoFormatter.vue";

import ContactUs from "../pages/contactUs/ContactUs.vue";


Vue.use(Router);

const routes = [
    { path: "", redirect: { name: "default" } },
    {
        path: "/playground",
        component: Body,
        beforeEnter: (to, from, next) => {
            const isDevOrLocal = process.env.NODE_ENV === 'development' || process.env.VUE_APP_EMP_ENV_NAME === 'DEV';
            if (isDevOrLocal) {
                next();
            } else {
                next('/'); // Redirect to home if not in dev/local
            }
        },
        children: [
            {
                path: "/",
                name: "Playground",
                component: ComponetPlayground,
                meta: {
                    title: "Component Playground",
                },
            }
        ]
    },
    {
        path: "/video-formatter",
        name: "VideoFormatter",
        component: VideoFormatter,
        meta: {
            title: "Video to MP4 Converter",
        },
    },
    {
        path: "/autoReport",
        component: Body,
        meta: {
            AccessRightIDs: ["999150", "999151"]
        },
        children: [
            {
                path: "/",
                name: "AutoReport",
                meta: {
                    AccessRightIDs: ["999150", "999151"]
                },
                component: AutoReport
            }
        ]

    },
    {
        path: "/openSearch",
        component: Body,
        meta: {
            AccessRightIDs: ["999130"],
        },
        children: [
            {
                path: "wordSplitter",
                name: "OpenSearchWordSplitter",
                meta: {
                    AccessRightIDs: ["999130"],
                },
                component: OpenSearchWordSplitter,
            }
        ]
    },
    {
        path: "/sourcingTrendAndMarketAnalysis",
        component: Body,
        meta: {
            // requiresAuth: true,
            AccessRightIDs: ["999120"]
        },
        children: [
            {
                path: "/",
                name: "SourcingTrendAndMarketAnalysis",
                component: SourcingTrendAndMarketAnalysis,
                meta: {
                    // requiresAuth: true,
                    AccessRightIDs: ["999120"]
                },
                children: [
                    {
                        name: "SourcingTrendAndMarketAnalysisDetail",
                        path: "detail/:type/:id",
                        component: SourcingTrendAndMarketAnalysisDetail,
                    }
                ]
            }
        ]
    },
    {
        path: "/PIG",
        component: Body,
        meta: {
            // requiresAuth: true,
        },
        children: [
            {
                alias: ['/productinnovationgallery', '/productinnovationgallery/', '/productinnovationgallery/default'],
                path: "default",
                name: "PIG",
                component: PIG,
                meta: {
                    title: "新闻信息中心 | eMarketplace 供應商中心",
                },
                children: [
                    {
                        path: "/PIG/Detail/:id",
                        name: "PIGDetail",
                        component: PIGDetail,
                    }
                ]
            },

        ],
    },
    {
        path: "/visitorGuide",
        component: Body,
        meta: {
            // requiresAuth: true,
        },
        children: [
            {
                path: "default",
                name: "VisitorGuide",
                component: visitorGuide,
                meta: {
                    title: "新闻信息中心 | eMarketplace 供應商中心",
                },
            },

        ],
    },
    {
        path: "/dashboard",
        component: Body,
        meta: {
            // requiresAuth: true,
        },
        children: [
            {
                path: "default",
                name: "default",
                component: Default,
                meta: {
                    title: "Homepage | eMarketplace 供應商中心",
                },
            },
        ],
    },
    {
        path: "/salesLead",
        component: Body,
        meta: {},
        redirect: "/salesLead/all",
        children: [
            {
                path: "default",
                name: "SalesLead",
                component: SalesLead,
                children:
                    [
                        {
                            path: "/salesLead/all",
                            name: "/salesLead/all"
                        },
                        {
                            path: "/salesLead/default",
                            name: "/salesLead/default"
                        },
                        {
                            path: "/salesLead/SourcingRequestMatched",
                            name: "/salesLead/SourcingRequestMatched"
                        },
                        {
                            path: "/salesLead/SourcingRequestApplied",
                            name: "/salesLead/SourcingRequestApplied"
                        },
                        {
                            path: "/salesLead/nameCard",
                            name: "/salesLead/nameCard"
                        },
                        {
                            path: "/salesLead/likeFollow",
                            name: "/salesLead/likeFollow"
                        }
                    ]
            }
        ]
    },
    {
        path: "/companyInfoCenter",
        component: Body,
        meta: {
            // requiresAuth: true,
        },
        children: [
            {
                path: "default",
                name: "Report",
                component: CompanyInfoCenter,
                meta: {
                    title: "公司资料中心 | eMarketplace 供應商中心",
                },
            }
        ],
    },
    {
        path: "/Report",
        component: Body,
        meta: {
            // requiresAuth: true,
        },
        children: [
            {
                path: "default",
                name: "CompanyInfoCenterDefault",
                component: Report,
                meta: {
                    title: "Report",
                },
            }
        ],
    },
    // {
    //     path: "/productInfoCenter",
    //     component: Body,
    //     meta: {
    //         // requiresAuth: true,
    //     },
    //     children: [
    //         {
    //             path: "default",
    //             name: "ProductInfoCenterDefault",
    //             component: ProductInfoCenter,
    //             meta: {
    //                 title: "产品资料中心 | eMarketplace 供應商中心",
    //             },
    //             children: [
    //                 {
    //                     path: "/productInfoCenter/productDetail/:id",
    //                     name: "/productInfoCenter/productDetail/:id",
    //                     component: ProductDetail,
    //                 },
    //                 {
    //                     path: "/productInfoCenter/indexDetail/:id",
    //                     name: "/productInfoCenter/indexDetail/:id",
    //                     component: ProductIndex,
    //                 }
    //             ]
    //         },

    //     ],
    // },
    {
        path: "/productInfoCenter",
        component: Body,
        meta: {
            // requiresAuth: true,
        },
        children: [
            {
                path: "default",
                name: "NewproductInfoCenterDefault",
                component: NewProductInfoCenter,
                meta: {
                    title: "新产品资料中心 | eMarketplace 供應商中心",
                },
                children: [
                    {
                        path: "/productInfoCenter/productDetail/:id",
                        name: "/productInfoCenter/productDetail/:id",
                        component: NewProductDetail,
                    },
                    {
                        path: "/productInfoCenter/indexDetail/:id",
                        name: "/productInfoCenter/indexDetail/:id",
                        component: NewProductIndex,
                    }
                ]
            },

        ],
    },
    {
        path: "/BuyerRequest",
        component: Body,
        meta: {
            // requiresAuth: true,
        },
        children: [
            {
                path: "default",
                name: "BuyerRequestDefault",
                component: BuyerRequest,
                meta: {
                    title: "采购墙 | eMarketplace 供應商中心",
                },
            },
        ],
    },
    {
        path: "/AdvertismentInfoCenter",
        component: Body,
        meta: {
            // requiresAuth: true,
        },
        children: [
            {
                path: "default",
                component: AdvertismentInfoCenter,
                meta: {
                    title: "广告宣传服务 | eMarketplace 供應商中心",
                },
                children: [
                    {
                        path: "",
                        name: "AdvertismentInfoCenter",
                        component: AdListView,
                    },
                    {
                        path: "detail",
                        name: "AdvertismentInfoCenterDetail",
                        component: AdDetailView,
                    },
                    {
                        path: "detail/:adDetailId",
                        name: "AdvertismentInfoCenterDetailById",
                        component: AdDetailView,
                    },
                ],
            }
        ],
    },
    {
        path: "/newsInfoCenter",
        component: Body,
        meta: {
            // requiresAuth: true,
            AccessRoles: ["USER"],
            AccessRightIDs: ["999110"]
        },
        children: [
            {
                path: "default",
                name: "NewsInfoCenter",
                component: NewsInfoCenter,
                meta: {
                    title: "新闻信息中心 | eMarketplace 供應商中心",
                    AccessRoles: ["USER"],
                    AccessRightIDs: ["999110"],
                },
                children: [
                    {
                        path: "/newsInfoCenter/newsDetail/:id",
                        name: "/newsInfoCenter/newsDetail/:id",
                        component: NewsDetail,
                        meta: {
                            AccessRoles: ["USER"],
                            AccessRightIDs: ["999110"],
                        },
                    }
                ]
            },

        ],
    },
    ...(BR_ENABLED ? [{
        path: "/businessDocuments",
        component: Body,
        meta: {
            kybExempt: true,
        },
        children: [
            {
                path: "default",
                name: "BusinessDocumentsDefault",
                component: BusinessDocumentsDefault,
                meta: {
                    title: "商业文件 | eMarketplace 供应商中心",
                    kybExempt: true,
                },
            },
            {
                path: "addDocument",
                name: "BusinessDocumentsAdd",
                component: BusinessDocumentsAdd,
                meta: {
                    title: "新增商业文件 | eMarketplace 供应商中心",
                    kybExempt: true,
                },
            },
        ],
    }] : []),
    {
        path: "/UserSetting",
        component: Body,
        children: [
            {
                path: "MyAccount",
                name: "MyAccount",
                component: MyAccount,
                meta: {
                    title: "我的帐户",
                },
            }
        ],
    },
    {
        path: "/UserSetting",
        component: Body,
        children: [
            {
                path: "MyUsers",
                name: "MyUsers",
                component: MyUsers,
                meta: {
                    title: "我的用户",
                },
            }
        ],
    },
    {
        path: "/SourcingRequestCenter",
        component: Body,
        children: [
            {
                path: "default",
                name: "SourcingRequestCenter",
                component: sourcingRequestCenter,
                meta: {
                    title: "采购需求中心 | eMarketplace 供應商中心",
                },
            }
        ],
    },
    {
        path: "/MyMessage",
        component: Body,
        children: [
            {
                path: "default",
                name: "MyMessage",
                component: MyMessage,
                meta: {
                    title: "我的信息 | eMarketplace 供應商中心",
                },
                children: [
                    {
                        path: "/MyMessage/Detail/:id",
                        name: "/MyMessage/Detail/:id",
                        component: MyMessageDetail,
                    }
                ]
            },

        ],
    },
    {
        path: "/aboutPlatform",
        component: Body,
        children: [
            {
                path: "officialNotice",
                name: "officialNotice",
                component: officialNotice,
                meta: {
                    title: "官方通知 | eMarketplace 供應商中心",
                },
            },
            {
                path: "sourcing_trend_market_analysis",
                name: "sourcing_trend_market_analysis",
                component: sourcing_trend_market_analysis,
                meta: {
                    title: "平台攻略 | eMarketplace 供應商中心",
                },
            }
        ],
    },
    {
        path: "/profile",
        component: Body,
        meta: {
            // requiresAuth: true,
        },
        children: [
            {
                path: "settings",
                name: "settings",
                component: settings,
                meta: {
                    title: "設定 | eMarketplace 供應商中心",
                },
            },
        ],
    },
    {
        path: "/management",
        meta: {
            kybExempt: true,
            // requiredAuths: ["999100", "999101"]
        },
        component: Body,
        children: [
            {
                path: "index",
                name: "index",
                component: managementIndex,
                meta: {
                    AccessRightIDs: ["999140"],
                    title: "管理員後台 | eMarketplace 供應商中心",
                }
            },
            {
                path: "supplier",
                name: "supplier",
                component: manageSupplier,
                meta: {
                    title: "管理員後台 | eMarketplace 供應商中心",
                    AccessRightIDs: ["999100", "999101"],
                },
            },
            {
                path: "AdApproval",
                name: "AdApproval",
                component: manageAdApproval,
                meta: {
                    title: "廣告審批後台 | eMarketplace 供應商中心",
                    AccessRightIDs: ["999100", "999170"],
                },
            },
             {
                path: "CompanyApproval",
                name: "CompanyApproval",
                component: manageCompanyApproval,
                meta: {
                    title: "公司資料審批後台 | eMarketplace 供應商中心",
                    AccessRightIDs: ["999100", "999180"],
                },
            },
            {
                path: "blacklist/default",
                name: "blacklist",
                component: managementBlacklist,
                meta: {
                    title: "管理員後台 | eMarketplace 供應商中心",
                    AccessRightIDs: ["999160"],
                },
            }
        ],
    },
    {
        path: "/hotSearches",
        component: Body,
        meta: {

        },
        children: [
            {
                path: "default",
                name: "HotSearches",
                component: HotSearchesDefault,
                meta: {
                    AccessRightIDs: [ "999161"],
                    title: "热门搜索管理 | eMarketplace 供应商中心",
                },
            },
        ],
    },
    {
        path: "/auth",
        component: Auth,
        meta: {
            kybExempt: true,
        },
        children: [
            {
                path: "login",
                name: "Login",
                component: login,
                meta: {
                    title: "Login | eMarketplace 供應商中心",
                    kybExempt: true,
                },
            },
            {
                path: "register",
                name: "register 1",
                component: Register,
                meta: {
                    title: " Register | eMarketplace 供應商中心",
                    kybExempt: true,
                },
            },
            {
                path: "ResetAccountPassword",
                name: "ResetAccountPassword 1",
                component: ResetAccountPassword,
                meta: {
                    title: " ResetAccountPassword | eMarketplace 供應商中心",
                    kybExempt: true,
                },
            },
            {
                path: "login-success-test",
                name: "LoginSuccessTest",
                component: LoginSuccessTest,
                meta: {
                    title: "登录成功测试 | eMarketplace 供應商中心",
                    kybExempt: true,
                },
            },
        ],
    },
    {
        path: "/authentication/login/one",
        name: "LoginOne",
        component: LoginOne,
        meta: {
            title: "LoginOne | eMarketplace 供應商中心",
        },
    },
    {
        path: "/authentication/login/two",
        name: "LoginTwo",
        component: LoginTwo,
        meta: {
            title: "LoginTwo | eMarketplace 供應商中心",
        },
    },
    {
        path: "/authentication/login/validate",
        name: "LoginValidate",
        component: LoginValidate,
        meta: {
            title: "LoginValidate | eMarketplace 供應商中心",
        },
    },
    {
        path: "/authentication/register/image",
        name: "RegisterImage",
        component: RegisterImage,
        meta: {
            title: "RegisterImage | eMarketplace 供應商中心",
        },
    },
    {
        path: "/authentication/register/image2",
        name: "RegisterImage2",
        component: RegisterImage2,
        meta: {
            title: "RegisterImage2 | eMarketplace 供應商中心",
        },
    },
    {
        path: "/ecommerce",
        component: Body,
        children: [
            {
                path: "product",
                name: "Product",
                component: Products,
                meta: {
                    title: "Products | Cuba - Premium Admin Template",
                },
            },
            {
                path: "details/:id",
                name: "Product Details",
                component: ProductDetails,
                meta: {
                    title: "ProductDetails | Cuba - Premium Admin Template",
                },
            },
            {
                path: "cart",
                name: "Cart",
                component: Cart,
                meta: {
                    title: "Cart | Cuba - Premium Admin Template",
                },
            },
            {
                path: "wishlist",
                name: "Wishlist",
                component: Wishlist,
                meta: {
                    title: "Wishlist | Cuba - Premium Admin Template",
                },
            },
            {
                path: "checkout",
                name: "Checkout",
                component: Checkout,
                meta: {
                    title: "Checkout | Cuba - Premium Admin Template",
                },
            },
            {
                path: "invoice",
                name: "Invoice",
                component: Invoice,
                meta: {
                    title: "Invoice | Cuba - Premium Admin Template",
                },
            },
            {
                path: "/orderHistory",
                name: "Order History",
                component: OrderHistory,
                meta: {
                    title: "OrderHistory | Cuba - Premium Admin Template",
                },
                children: [
                    {
                        path: "/orderHistory/Detail/:id",
                        name: "/orderHistory/Detail/:id",
                        component: OrderHistoryDetail,
                    }
                ]
            },
            {
                path: "payment/details",
                name: "payment Details",
                component: PaymentDetails,
                meta: {
                    title: "PaymentDetails | Cuba - Premium Admin Template",
                },
            },
            {
                path: "/success",
                name: "Success",
                component: Success,
                meta: {
                    title: "Success | Cuba - Premium Admin Template",
                },
            },
        ],
    },

    {
        path: "/error-400",
        name: "Error400",
        component: Error400,
        meta: {
            title: "Error400 | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/error-401",
        name: "Error401",
        component: Error401,
        meta: {
            title: "Error401 | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/error-403",
        name: "Error403",
        component: Error403,
        meta: {
            title: "Error403 | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/error-404",
        name: "Error404",
        component: Error404,
        meta: {
            title: "Error404 | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/error-500",
        name: "Error500",
        component: Error500,
        meta: {
            title: "Error500 | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/error-503",
        name: "Error503",
        component: Error503,
        meta: {
            title: "Error503 | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/contact-us",
        name: "ContactUs",
        component: ContactUs,
        meta: {
            title: "Contact Us | eMarketplace",
        },
    },

];

const router = new Router({
    routes,
    base: process.env.VUE_APP_ROUTE_PATH,
    mode: "history",
    linkActiveClass: "active",
    scrollBehavior(to, from, savedPosition) {

        if (to.hash) {
            return {
                selector: to.hash,
                behavior: 'smooth',
            };
        }
        return { x: 0, y: 0 };
    },
});

export default router;
